import {
  OrganizationInterop,
  OrganizationInteropParameterMapping,
  OrganizationInteropUpdatePayload,
} from '../../../model/OrganizationInterop'

const serializeParameterMapping = (
  mapping: OrganizationInteropParameterMapping,
): OrganizationInteropParameterMapping => ({
  paramName: mapping.paramName,
  field: mapping.field,
  required: !!mapping.required,
  transform:
    mapping.transform === undefined ||
    mapping.transform === null ||
    String(mapping.transform).trim() === ''
      ? null
      : String(mapping.transform).trim(),
})

export const serializeOrganizationInteropUpdate = (
  organizationInterop: Partial<OrganizationInterop>,
): OrganizationInteropUpdatePayload => ({
  name: organizationInterop.name || '',
  code: organizationInterop.code || '',
  mainDoctorId: organizationInterop.mainDoctor?.internalId ?? null,
  ...((organizationInterop.users || []).length > 0 && {
    userIds: (organizationInterop.users || []).map((user) => user.internalId),
  }),
  ...((organizationInterop.urlTemplates || []).length > 0 && {
    urlTemplates: (organizationInterop.urlTemplates || []).map((template) => ({
      ...(template.id && { id: template.id }),
      host: template.host,
      name: template.name,
      parameterMappings: (template.parameterMappings || []).map(serializeParameterMapping),
      isActive: template.isActive ?? true,
    })),
  }),
})
